import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { faBars, faCalendar, faCircleInfo, faEnvelope, faGem, faHouse, faPhone, faRightFromBracket, faRightToBracket, faShop, faTractor, faUser, faUserTie } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule } from '@angular/common';
import { OrganisationSlugReverseMap, RouteName } from '../../models/enums';
import { Router, RouterOutlet, RouterModule, NavigationEnd, ActivatedRoute } from '@angular/router';
import { OnInit } from '@angular/core';
import { Organisation } from '../../models/types';
import { LoginService } from '../services/login.service';
import { filter } from 'rxjs/operators';
import { faFacebook, faTwitter, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { OrganisationSlugMap } from '../../models/enums';
import { OrganisationServiceService } from '../services/organisation-service.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [FontAwesomeModule, CommonModule, RouterModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {

  @Input() onRegisterPage = false;
  @Input() bgColor: string = '#222';

  faGem = faGem;
  faShop = faShop;
  faCalendar = faCalendar;
  faTractor = faTractor;
  faRightToBracket = faRightToBracket;
  faRightFromBracket = faRightFromBracket;
  faUser = faUser;
  faBars = faBars;
  faUserTie = faUserTie;
  faCircleInfo = faCircleInfo;
  faHouse = faHouse;
  faHome = faHouse;
  faEnvelope = faEnvelope;
  faPhone = faPhone;
  faFacebook = faFacebook;
  faInstagram = faInstagram;

  marketRoute = RouteName.market;
  calendarRoute = RouteName.calendar
  farmsRoute = RouteName.farms;
  helpRoute = RouteName.help;
  homeRoute = RouteName.home;
  registerRoute = RouteName.register;

  onKSRoute = false;
  onSDRoute = false;
  onPGDRoute = false;
  onLDRoute = false;
  onKTDRoute = false;
  onZRoute = false;
  onHomeRoute = false;

  public organisations: Organisation[] = [];
  public currentOrganisation: Organisation | null = null;

  constructor(
    private router: Router, 
    private loginService: LoginService, 
    private cdr: ChangeDetectorRef, 
    private activatedRoute: ActivatedRoute,
    private organisationService: OrganisationServiceService) { }

  ngOnInit(): void {
    this.loadOrganisations();
  
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const currentUrl = this.router.url;
      console.log('In footer component:', currentUrl);
  
      const slug = this.extractSlugFromUrl(currentUrl);
      if (slug) {
        const orgName = OrganisationSlugMap[slug];

        if (orgName) {
          this.organisationService.getOrganisationIdByName(orgName).subscribe({
            next: (response) => {
              const organisationID = response.body?.organisationID;
              if (organisationID) {
                this.setCurrentOrganisationById(String(organisationID));
              }
            },
            error: (err) => {
              console.error('Error fetching organisation by name from footer:', err);
            }
          });
        } else {
          this.currentOrganisation = null;
        }
      } else {
        this.currentOrganisation = null;
      }
    });
  }
  
  private extractSlugFromUrl(url: string): string | null {
    const match = url.match(/\/organisation\/([\w-]+)/); // Matches /organisation/{slug}
    return match ? match[1] : null;
  }
  
  normalizeName(name: string): string {
    return name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  loadOrganisations() {
    this.loginService.getAllOrganisations().subscribe({
      next: (response) => {
        if (response.body && Array.isArray(response.body.organisations)) {
          this.organisations = response.body.organisations
          .filter((org: Organisation) => org.organisationID !== -1)
          .map((org: Organisation) => {
            const normalizedName = this.normalizeName(org.name);
            const slug = OrganisationSlugReverseMap[normalizedName]
            return {
              ...org,
              slug: slug || ''
            };
          });
          console.log('Loaded organisations:', this.organisations);
          this.cdr.detectChanges(); // Manually trigger change detection
  
          const slug = this.extractSlugFromUrl(this.router.url);
          const orgName = OrganisationSlugMap[slug!];
  
          if (orgName) {
            const matchingOrg = this.organisations.find(org => org.name === orgName);
            if (matchingOrg) {
              this.setCurrentOrganisationById(String(matchingOrg.organisationID));
            } else {
              console.warn('Organisation not found for name:', orgName);
            }
          } else {
            console.warn('Slug not found or invalid:', slug);
          }
  
        } else {
          console.error('Unexpected response structure:', response.body);
        }
      },
      error: (err) => {
        console.error('Error fetching organisations:', err);
      }
    });
  }
  

  // Set the current organisation based on the route
  private setCurrentOrganisationById(organisationId: string): void {
    const id = parseInt(organisationId, 10);  // Convert string to number
    console.log('Setting current organisation for ID:', id);
    this.currentOrganisation = this.organisations.find(org => org.organisationID === id) || null; 
    
    if (this.currentOrganisation) {
      console.log(`Loaded organisation for ID: ${organisationId}`);
    } else {
      console.error(`Organisation not found for ID: ${organisationId}`);
    }
  }
}

